import { fexPut } from "@/utils/fex"

export const changePageStyle = ({pageName,style}:{pageName:string,style:string})=>{
    fexPut("api/page/style/"+pageName,{style})
}

export const  changeSectionStyle = ({sectionId,style}:{sectionId:string,style:string})=>{
    fexPut("api/section/style/"+sectionId,{style})
}
